<template>
	<div class="signature">

		<div class="mx-4 offer-signature-table">
			<v-layout row>
				<table style="width:100%; border: 1px solid black; border-collapse: collapse">
					<tr style="height: 35px; border: 1px solid black">
						<th style="padding: 5px; font-size: 13px; width: 30%; text-align: center; border: 1px solid black">
							Miejscowość, data
						</th>
						<th style="padding: 5px; font-size: 13px; width: 40%; text-align: center; border: 1px solid black">
							Imię i
							nazwisko osoby podpisującej
						</th>
						<th style="padding: 5px; font-size: 13px; width: 30%; text-align: center; border: 1px solid black">
							Podpis
						</th>
					</tr>
					<tr style="height: 60px">
						<td style="border: 1px solid black"></td>
						<td style="border: 1px solid black"></td>
						<td style="border: 1px solid black"></td>
					</tr>
				</table>
			</v-layout>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'ReportSignature'
	};
</script>
<style scoped>
	.theme--dark th, .theme--dark td {
		border: solid 1px white !important;
	}
</style>
